import React, { useCallback, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { Field, FieldProps, Form as FormikForm, Formik } from 'formik'

import { Form, LayoutItem } from '../../../ana-toolbox'
import { FormProps, preparations } from '../../../ana-toolbox/ana-toolbox'
import { FormLayout } from '../../components/form-layout/form-layout'
import { SubmitButton } from '../../components/submit-button/submit-button'
import { WishesToggleField } from '../../components/wishes-toggle-field/wishes-toggle-field'
import { validationSchema } from '../../utils/fields/wishesAndExpectations'
import { getFormInitialErrors } from '../../utils/helpers/getFormInitialErrors'
import { combinedFields } from '../../utils/yup/main'

export const PreparationsForm = ({ initialValues = {}, onSubmit, loading, innerRef, portalAttr }: FormProps) => {
  const { t } = useTranslation()

  const layout = useMemo(() => {
    return [
      ...preparations.map((preparation): LayoutItem => {
        return {
          type: 'custom',
          key: preparation.key,
          xs: 12,
          render: () => <WishesToggleField wishKey={preparation.key} label={`field.${preparation.key}`} />,
        }
      }),
      { type: 'field', field: combinedFields.isPregnant, xs: 12 },
      { type: 'field', field: combinedFields.pregnantMonths, xs: 12 },
    ]
  }, [])

  const handleSubmit = useCallback(
    (values: Partial<Form>) => {
      onSubmit(values)
    },
    [onSubmit]
  )

  const submitButton = (
    <Field>
      {(props: FieldProps) => {
        return (
          <SubmitButton onClick={() => props.form.submitForm()} disabled={!props.form.isValid} loading={loading}>
            {t('next')}
          </SubmitButton>
        )
      }}
    </Field>
  )

  const currentKeys = preparations.map((w) => w.key)

  return (
    <Formik
      initialErrors={getFormInitialErrors(validationSchema(currentKeys), initialValues)}
      validationSchema={validationSchema(currentKeys)}
      innerRef={innerRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <FormLayout portalAttr={portalAttr} items={layout as LayoutItem[]} submitButton={submitButton} />
      </FormikForm>
    </Formik>
  )
}
